// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2Ii1N","head":"ProcedureTableInfo_head__16snT"};